exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".warning-bar {\n  width: 100%;\n  height: 30px;\n  line-height: 30px;\n  border: 1px solid #d3d8dd;\n  background: #f2f4f6;\n  border-radius: 3px;\n  margin: 11px 0 11px;\n  display: table;\n  color: #5d6368; }\n  .warning-bar .anticon {\n    color: #5d6368;\n    margin: 0 10px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/common/components/WarningBar/style.scss
// module id = 1028
// module chunks = 0